export enum PrintProductDocumentOrderField {
	Id = 'Id',
	Epc = 'Epc',
	SerialNumber = 'SerialNumber',
	Verified = 'Verified',
	PrintStatus = 'PrintStatus',
}
